import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import BackLink from '~/components/patterns/links/BackLink';
import HeaderTitleLayout from '~/components/atoms/screenLayouts/components/header/layouts/HeaderTitleLayout';
import HeaderTitleWithValue from '~/components/atoms/screenLayouts/components/header/headerTitle/HeaderTitleWithValue';
import ScreenHeader from '~/components/patterns/screens/basicScreen/header/ScreenHeader';
import ScrollableContentScreen from '~/components/logic/layouts/screens/ScrollableContentScreen';
import UserProfileContent from '~/components/logic/memberDetail/UserProfileContent';



const SectionRoutes = {
	emailSettings: 'userProfile.emailSettings',
	personalSettings: 'userProfile',
};

const messages = defineMessages({
	backToTeamMembers: {
		id: 'ui.userProfile.backToTeamMembers',
	},
	title: {
		id: 'ui.userProfile.title',
	},
});



type Props = {
	backlink: any,
	closeCallback: () => void,
};

const UserProfileScreen: React.FC<Props> = (props) => {
	const {
		backlink,
		closeCallback,
	} = props;

	return (
		<ScrollableContentScreen
			header={(
				<ScreenHeader>
					<HeaderTitleLayout>
						{backlink === 'account.members' && (
							<BackLink
								label={(
									<FormattedMessage {...messages.backToTeamMembers} />
								)}
								onClickCallback={closeCallback}
							/>
						)}

						<HeaderTitleWithValue
							title={(
								<FormattedMessage {...messages.title} />
							)}
						/>
					</HeaderTitleLayout>
				</ScreenHeader>
			)}
			withPadding={false}
		>
			<UserProfileContent
				getSectionRoute={(section) => SectionRoutes[section]}
			/>
		</ScrollableContentScreen>
	);
};



export default UserProfileScreen;
